import React from 'react';
import { Box, Typography } from '@mui/material';
import { UploadProgressProps } from '../types';

const UploadProgress: React.FC<UploadProgressProps> = ({ progress, isVisible }) => {
  if (!isVisible) return null;

  return (
    <Box mb={2}>
      <Typography variant="body2" color="text.secondary" mb={1}>
        Progreso de subida: {Math.round(progress)}%
      </Typography>
      <Box
        sx={{
          width: '100%',
          height: 8,
          backgroundColor: 'grey.300',
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: 'primary.main',
            transition: 'width 0.2s ease-in-out',
          }}
        />
      </Box>
    </Box>
  );
};

export default UploadProgress;
